<template>
  <el-row
    type="flex"
    justify="space-between"
    align="middle"
  >
    <div>
      <h1 class="card-container__title">{{ title }} <span class="card-container__subtitle">({{ total }})</span></h1>
    </div>
    <el-row
      class="card-container__actions"
      type="flex"
      justify="end"
      align="middle"
    >
      <el-button
        v-if="permission.CREATE"
        type="primary"
        size="medium"
        icon="el-icon-plus"
        :disabled="disabled"
        :plain="plain"
        @click="$emit('create')"
        >Thêm mới</el-button
      >
      <el-button
        type="primary"
        size="medium"
        icon="el-icon-refresh"
        :plain="plain"
        :disabled="disabled"
        @click="$emit('refresh')"
        >Làm mới</el-button
      >
      <ExportExcelButton
        v-if="config"
        class="ml-s"
        :title="title"
        :disabled="disabled"
        :total="total"
        :columns="columns"
        :object-type="objectType"
        :type="type"
      />
      <ImportExcelButton
        v-if="config && permission.CREATE"
        class="ml-s"
        :title="title"
        :disabled="disabled"
        :total="total"
        :columns="columns"
        :object-type="objectType"
        :type="type"
        @reload="() => $emit('refresh')"
      />
    </el-row>
  </el-row>
</template>

<script>
import ExportExcelButton from "../../../components/buttons/ExportExcel.vue";
import ImportExcelButton from "../../../components/buttons/ImportExcel.vue";

export default {
  name: "CardHeader",
  components: {
    ExportExcelButton,
    ImportExcelButton,
  },
  props: {
    config: Object,
    total: Number,
    disabled: Boolean,
    plain: Boolean,
    size: String,
    permission: Object
  },
  computed: {
    title() {
      return this.config.extra.name || "";
    },
    columns() {
      const data = this.config.extra?.fields || [];
      return data
        .filter((i) => i.show.import_export)
        .sort((a, b) => a.order - b.order);
    },
    objectType() {
      return this.config.type;
    },
    type() {
      return this.config.extra.key;
    },
  },
};
</script>

<style lang="scss" scoped></style>
